import { render, staticRenderFns } from "./JcdcFlashMessage.vue?vue&type=template&id=4489ca7d"
import script from "./JcdcFlashMessage.vue?vue&type=script&lang=ts"
export * from "./JcdcFlashMessage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports